export default __webpack_public_path__ + "static/media/tb.a0b973b3.png";